"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdFormik = require("cccisd-formik");
var _eye = _interopRequireDefault(require("cccisd-icons/eye2"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _admin = require("../../../reducers/admin");
var _index = _interopRequireDefault(require("./Preview/index.js"));
var _WithModulesForm = _interopRequireDefault(require("./WithModulesForm"));
var _General = require("./WithModulesForm/General");
var _Modules = require("./WithModulesForm/Modules");
var _Pinned = require("./WithModulesForm/Pinned");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var WithModulesModal = function WithModulesModal(_ref) {
  var assignmentData = _ref.assignmentData,
    isWithModulesUnsavedChanges = _ref.isWithModulesUnsavedChanges,
    setIsWithModulesUnsavedChanges = _ref.setIsWithModulesUnsavedChanges;
  var dispatch = (0, _reactRedux.useDispatch)();

  // Used this to position Draggables correctly
  // https://github.com/atlassian/react-beautiful-dnd/issues/1881#issuecomment-691237307
  var contentRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    draggableOffset = _useState2[0],
    setDraggableOffset = _useState2[1];
  function calculateDraggableOffset() {
    if (contentRef.current) {
      var modalDomEl = null;
      var childDomEl = contentRef.current;
      while (childDomEl && !modalDomEl) {
        var classNames = childDomEl.className || '';
        if (classNames.includes('ReactModal__Content')) {
          modalDomEl = childDomEl;
          break;
        }
        childDomEl = childDomEl.parentElement;
      }
      if (modalDomEl) {
        var rect = modalDomEl.getBoundingClientRect();
        setDraggableOffset({
          x: rect.x,
          y: rect.y
        });
      }
    }
  }
  (0, _react.useEffect)(function () {
    (0, _debounce2["default"])(calculateDraggableOffset, 1500)();
  }, [contentRef]);
  (0, _react.useEffect)(function () {
    var debounced = (0, _debounce2["default"])(calculateDraggableOffset, 1500);
    window.addEventListener('resize', debounced);
    return function () {
      return window.removeEventListener('resize', debounced);
    };
  }, []);

  // is the withModules selected at top-level or nested? Can be multiple!
  var possiblePrefixes = [
  // made-up key so code handles Course Wrapper and non-Course Wrapper the same
  'settings.navigationSettings.topLevel', 'settings.navigationSettings.course', 'settings.navigationSettings.courseEval', 'settings.navigationSettings.finalTest', 'settings.navigationSettings.registration'];
  var usedPrefixes = possiblePrefixes.reduce(function (all, currPrefix) {
    var isCheckingTopLevel = currPrefix.includes('topLevel');
    var isPrefixUsed = false;
    if (isCheckingTopLevel) {
      isPrefixUsed = (0, _get2["default"])(assignmentData, "settings.navigation", '').match(/^module/);
    } else {
      isPrefixUsed = (0, _get2["default"])(assignmentData, "settings.navigation", '').match(/^courseWrapper/) && (0, _get2["default"])(assignmentData, "".concat(currPrefix, ".navigation"), '').match(/^module/);
    }
    if (isPrefixUsed) {
      var label = isCheckingTopLevel ? (0, _get2["default"])(assignmentData, 'label', 'Quest') : (0, _get2["default"])(assignmentData, "".concat(currPrefix, ".tabName"));
      return _objectSpread(_objectSpread({}, all), {}, _defineProperty({}, currPrefix.replace(/^settings\.navigationSettings\.{1}/, ''), label));
    }
    return all;
  }, {});

  /*
   *   We need to pack/unpack to maintain backwards compatibility.
   *   JSON structure of this Form is different than what actually gets saved
   *   in assignment settings.
   */
  function unpackInitialSettings() {
    var initialValues = {
      currentPrefix: Object.keys(usedPrefixes)[0] + '.navigationSettings'
    };
    var allDefaults = _objectSpread(_objectSpread(_objectSpread({}, _General.initialValues), _Modules.initialValues), _Pinned.initialValues);
    Object.keys(usedPrefixes).forEach(function (prefix) {
      (0, _set2["default"])(initialValues, "".concat(prefix, ".navigationSettings"), (0, _cloneDeep2["default"])(allDefaults));
      var existing = prefix === 'topLevel' ? assignmentData.settings.navigationSettings : (0, _get2["default"])(assignmentData, "settings.navigationSettings.".concat(prefix, ".navigationSettings"), {}) || {};

      // PHP converts empty objects to arrays, so can't rely on object
      if (_typeof(existing) === 'object' && !Array.isArray(existing)) {
        var _loop = function _loop() {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          if (key === 'modules') {
            var _existing$pinnedConte;
            var unpackedModuleMap = {};
            value.forEach(function (module) {
              if (!unpackedModuleMap[module.id]) {
                unpackedModuleMap[module.id] = Array.isArray(module.surveyHandles) ? {
                  surveyHandles: module.surveyHandles
                } : {
                  surveyHandles: []
                };
              }
              if ('visibility' in module) {
                unpackedModuleMap[module.id].visibility = module.visibility;
              }
              if ('unlockAfter' in module) {
                unpackedModuleMap[module.id].unlockAfter = module.unlockAfter;
              }
              if (module.language === 'en') {
                if ('header' in module) {
                  unpackedModuleMap[module.id].headerEn = module.header;
                }
                if ('title' in module) {
                  unpackedModuleMap[module.id].titleEn = module.title;
                }
                if ('icon' in module) {
                  unpackedModuleMap[module.id].iconEn = module.icon;
                }
              } else if (module.language === 'es') {
                if ('header' in module) {
                  unpackedModuleMap[module.id].headerEs = module.header;
                }
                if ('title' in module) {
                  unpackedModuleMap[module.id].titleEs = module.title;
                }
                if ('icon' in module) {
                  unpackedModuleMap[module.id].iconEs = module.icon;
                }
              }

              // for backwards compatibility when previewing
              if (module.overview) {
                unpackedModuleMap[module.id].overview = module.overview;
              }
            });
            assignmentData.currentSurveylistList.surveyList.forEach(function (surv) {
              var _surv$settings, _surv$settings2, _surv$settings2$modul;
              // Old structure of Survey settings JSON for backwards compatibility
              if (surv !== null && surv !== void 0 && (_surv$settings = surv.settings) !== null && _surv$settings !== void 0 && _surv$settings.moduleId && unpackedModuleMap[surv.settings.moduleId] && !unpackedModuleMap[surv.settings.moduleId].surveyHandles.includes(surv.surveyHandle)) {
                unpackedModuleMap[surv.settings.moduleId].surveyHandles.push(surv.surveyHandle);
              }

              // New structure of Survey settings JSON
              if (prefix === 'topLevel' && Array.isArray(surv === null || surv === void 0 ? void 0 : (_surv$settings2 = surv.settings) === null || _surv$settings2 === void 0 ? void 0 : (_surv$settings2$modul = _surv$settings2.moduleIds) === null || _surv$settings2$modul === void 0 ? void 0 : _surv$settings2$modul.all)) {
                surv.settings.moduleIds.all.forEach(function (moduleId) {
                  if (!unpackedModuleMap[moduleId].surveyHandles.includes(surv.surveyHandle)) {
                    unpackedModuleMap[moduleId].surveyHandles.push(surv.surveyHandle);
                  }
                });
              }
              if (prefix !== 'topLevel' && Array.isArray((0, _get2["default"])(surv, "settings.moduleIds.".concat(prefix)))) {
                surv.settings.moduleIds[prefix].forEach(function (moduleId) {
                  if (!unpackedModuleMap[moduleId].surveyHandles.includes(surv.surveyHandle)) {
                    unpackedModuleMap[moduleId].surveyHandles.push(surv.surveyHandle);
                  }
                });
              }
            });
            var initialPinnedContent = existing !== null && existing !== void 0 && (_existing$pinnedConte = existing.pinnedContent) !== null && _existing$pinnedConte !== void 0 && _existing$pinnedConte.topLevel ? {
              topLevel: existing.pinnedContent.topLevel
            } : {
              topLevel: []
            };
            var initialModules = [];
            Object.keys(unpackedModuleMap).forEach(function (mId) {
              var id = parseInt(mId, 10);
              initialPinnedContent[id - 1] = {};
              initialPinnedContent[id - 1].topLevel = (0, _get2["default"])(existing, "pinnedContent.".concat(id - 1, ".topLevel")) ? existing.pinnedContent[id - 1].topLevel : [];
              unpackedModuleMap[mId].surveyHandles.forEach(function (surveyHandle) {
                initialPinnedContent[id - 1][surveyHandle] = (0, _get2["default"])(existing, "pinnedContent.".concat(id - 1, ".").concat(surveyHandle)) ? existing.pinnedContent[id - 1][surveyHandle] : [];
              });
              initialModules.push(_objectSpread({
                id: id
              }, unpackedModuleMap[mId]));
            });
            (0, _set2["default"])(initialValues, "".concat(prefix, ".navigationSettings.modules"), initialModules);
            (0, _set2["default"])(initialValues, "".concat(prefix, ".navigationSettings.pinnedContent"), initialPinnedContent);
          } else if (key === 'pinnedContent') {
            // do nothing, since it is handled when unpacking `modules` key
          } else {
            (0, _set2["default"])(initialValues, "".concat(prefix, ".navigationSettings.").concat(key), value);
          }
        };
        for (var _i = 0, _Object$entries = Object.entries(existing); _i < _Object$entries.length; _i++) {
          _loop();
        }
      }
    });
    return initialValues;
  }

  /*
   *   We need to pack/unpack to maintain backwards compatibility.
   *   JSON structure of this Form is different than what actually gets saved
   *   in assignment settings.
   */
  function packFinalSettings(vals) {
    var finalValues = (0, _cloneDeep2["default"])(vals);
    delete finalValues.currentPrefix;
    var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []) || [];
    var isEnglish = buildLanguages.includes('en');
    var isSpanish = buildLanguages.includes('es');
    var finalSettings = (0, _cloneDeep2["default"])(assignmentData.settings);
    Object.keys(usedPrefixes).forEach(function (prefix) {
      var currentValues = (0, _get2["default"])(vals, "".concat(prefix, ".navigationSettings"), null);
      if (!currentValues) {
        return;
      }

      // don't modify formik state directly!
      currentValues = (0, _cloneDeep2["default"])(currentValues);
      var packedModules = [];
      if (Array.isArray(currentValues.modules) && currentValues.modules.length > 0) {
        currentValues.modules.forEach(function (mod) {
          var omitWhenCopying = ['headerEn', 'headerEs', 'titleEn', 'titleEs', 'iconEn', 'iconEs'];
          if (isEnglish) {
            var packedModule = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, 'headerEn' in mod ? {
              header: mod.headerEn
            } : {}), 'titleEn' in mod ? {
              title: mod.titleEn
            } : {}), 'iconEn' in mod ? {
              icon: mod.iconEn
            } : {}), {}, {
              language: 'en'
            }, mod);
            omitWhenCopying.forEach(function (k) {
              return delete packedModule[k];
            });
            packedModules.push(packedModule);
          }
          if (isSpanish) {
            var _packedModule = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, 'headerEs' in mod ? {
              header: mod.headerEs
            } : {}), 'titleEs' in mod ? {
              title: mod.titleEs
            } : {}), 'iconEs' in mod ? {
              icon: mod.iconEs
            } : {}), {}, {
              language: 'es'
            }, mod);
            omitWhenCopying.forEach(function (k) {
              return delete _packedModule[k];
            });
            packedModules.push(_packedModule);
          }
        });
      }
      currentValues.modules = packedModules;
      if (prefix === 'topLevel') {
        (0, _set2["default"])(finalSettings, 'navigationSettings', currentValues);
      } else {
        (0, _set2["default"])(finalSettings, "navigationSettings.".concat(prefix, ".navigationSettings"), currentValues);
      }
    });
    return finalSettings;
  }
  function handleSubmit(_x, _x2) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values, actions) {
      var _response$data;
      var finalSettings, response, _response$data2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            finalSettings = packFinalSettings(values);
            _context.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.update'), {
              assignmentId: assignmentData.assignmentId,
              settings: finalSettings
            });
          case 1:
            response = _context.v;
            if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success')) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return dispatch((0, _admin.reloadCurrentProject)());
          case 2:
            (0, _cccisdNotification["default"])({
              message: 'Dashboard saved successfully!',
              type: 'success',
              duration: 3000
            });
            _context.n = 4;
            break;
          case 3:
            (0, _cccisdNotification["default"])({
              message: 'Failed to save dashboard changes',
              type: 'danger',
              data: response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errors,
              duration: 0
            });
          case 4:
            actions.resetForm(values);
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  function getIsUnsavedChanges(formikBag) {
    return Object.keys(formikBag.touched).some(function (k) {
      return k !== 'currentPrefix';
    });
  }
  function renderButtons(formikBag) {
    var isHighlightSave = getIsUnsavedChanges(formikBag);
    var isSubmitting = formikBag.isSubmitting;
    var prefixKey = ((0, _get2["default"])(formikBag, 'values.currentPrefix', '') || '').replace('.navigationSettings', '');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].buttons
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: isSubmitting ? 'Saving' : 'Save',
      className: 'btn ' + (isHighlightSave && !isSubmitting ? 'btn-warning' : 'btn-secondary'),
      type: "submit",
      isLoading: isSubmitting,
      onClick: formikBag.handleSubmit
    }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      contentStyle: {
        maxWidth: '1300px'
      },
      size: "calc(100vw - 30px)",
      title: "Preview Dashboard for ".concat(usedPrefixes[prefixKey]),
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-secondary",
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_eye["default"], {
        spaceRight: true
      }), "Preview"),
      render: function render(_ref2) {
        var closeModal = _ref2.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_index["default"], {
          assignmentData: assignmentData,
          closeModal: closeModal,
          formikBag: formikBag
        });
      }
    }));
  }
  function renderDropdown(formikBag) {
    if (Object.keys(usedPrefixes).length <= 1) {
      return null;
    }
    var isDisabled = Object.keys(formikBag.touched).some(function (k) {
      return k !== 'currentPrefix';
    });
    var dropdown = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].tabDropdown
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "currentPrefix",
      disabled: isDisabled,
      component: _cccisdFormik.CccisdSelect,
      label: "Which tab?",
      options: Object.keys(usedPrefixes).map(function (prefKey) {
        return {
          value: prefKey + '.navigationSettings',
          label: usedPrefixes[prefKey]
        };
      })
    }));
    return isDisabled ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Must save changes before configuring another tab."
    }, dropdown) : dropdown;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: contentRef
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: unpackInitialSettings(),
    onSubmit: handleSubmit,
    validate: function validate(values) {
      var errors = {};
      errors = (0, _Modules.validate)(values, errors, assignmentData);
      return errors;
    }
  }, function (formikBag) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, renderButtons(formikBag), renderDropdown(formikBag), formikBag.values.currentPrefix && /*#__PURE__*/_react["default"].createElement(_WithModulesForm["default"], {
      formikBag: formikBag,
      assignmentData: assignmentData,
      draggableOffset: draggableOffset,
      getIsUnsavedChanges: getIsUnsavedChanges,
      isWithModulesUnsavedChanges: isWithModulesUnsavedChanges,
      setIsWithModulesUnsavedChanges: setIsWithModulesUnsavedChanges
    }));
  }));
};
var _default = exports["default"] = WithModulesModal;